import { ref } from "vue";

export type MenuFavorite = {
	route: string;
	header: string;
	title?: string;
	icon?: string;
};

const STORAGE_PREFIX = "devares.menu.favorites.v1.";
const MAX_FAVORITES = 10;

/** Закреплённые пункты меню (реактивно для сайдбара) */
export const menuFavorites = ref<MenuFavorite[]>([]);

let currentUserKey = "anon";

function storageKey(userId?: string | number | null) {
	const id =
		userId != null && String(userId).trim() !== ""
			? String(userId)
			: currentUserKey;
	return `${STORAGE_PREFIX}${id}`;
}

export function loadMenuFavorites(userId?: string | number | null) {
	currentUserKey =
		userId != null && String(userId).trim() !== ""
			? String(userId)
			: "anon";
	try {
		const raw = localStorage.getItem(storageKey(currentUserKey));
		if (!raw) {
			menuFavorites.value = [];
			return;
		}
		const parsed = JSON.parse(raw);
		if (!Array.isArray(parsed)) {
			menuFavorites.value = [];
			return;
		}
		menuFavorites.value = parsed
			.filter(
				(x) =>
					x &&
					typeof x.route === "string" &&
					x.route &&
					typeof x.header === "string",
			)
			.slice(0, MAX_FAVORITES)
			.map((x) => ({
				route: String(x.route),
				header: String(x.header),
				title: x.title ? String(x.title) : undefined,
				icon: x.icon ? String(x.icon) : "icon icon-menu",
			}));
	} catch {
		menuFavorites.value = [];
	}
}

function persist() {
	try {
		localStorage.setItem(
			storageKey(currentUserKey),
			JSON.stringify(menuFavorites.value),
		);
	} catch {
		/* ignore quota */
	}
}

export function isMenuFavorite(route?: string | null): boolean {
	if (!route) return false;
	return menuFavorites.value.some((f) => f.route === route);
}

export function toggleMenuFavorite(
	item: {
		route?: string;
		header?: string;
		title?: string;
		icon?: string;
	},
	userId?: string | number | null,
): boolean {
	if (userId != null) loadMenuFavorites(userId);
	const route = item?.route;
	if (!route) return false;

	const idx = menuFavorites.value.findIndex((f) => f.route === route);
	if (idx >= 0) {
		menuFavorites.value = menuFavorites.value.filter((_, i) => i !== idx);
		persist();
		return false;
	}

	const next: MenuFavorite = {
		route,
		header: item.header || item.title || route,
		title: item.title || item.header || route,
		icon: item.icon || "icon icon-menu",
	};
	menuFavorites.value = [next, ...menuFavorites.value].slice(0, MAX_FAVORITES);
	persist();
	return true;
}
